/* eslint-disable no-sequences */
import Axios from "axios"
import {
  LOC_HIERARCHY_URLS as URLS,
  getFlagCheckPathSAAS,
  getAddOnHeaders,
  getAddOnHeadersGlobal,
  LOC_HIERARCHY_LIVE_URLS,
} from "../../../utils/url"
import UserService from "../../UserService"
import { JSUtils } from "@utils"
const CancelToken = Axios.CancelToken

//PATH VARIABLE REPLACER
function bindPath(url, pathVal) {
  var newUrl = url
  var pathExpression = /:[a-z0-9]+/gi
  var pathVar
  while (((pathVar = pathExpression.exec(url)), pathVar != null)) {
    let pathVarName = pathVar[0]
    newUrl = newUrl.replace(
      pathVarName,
      pathVal[pathVarName.substring(1, pathVarName.length)]
    )
  }
  return newUrl
}

const locationAxios = Axios.create()

locationAxios.interceptors.request.use(
  async function (config) {
    config.baseURL = config?.baseURL || URLS.baseURL
    const { isSaasView = false } = config || {}
    // //CHECK REQUEST NEED TO ADD AUTH TOKEN IN THE HEADER
    if (UserService.isLoggedIn()) {
      if (UserService.isAuthExpired() === true) {
        const myData = await UserService.updateRefreshToken()
        if (myData === true) {
          let mydataToken = UserService.getToken((res) => {
            return res
          })
          localStorage.setItem("token", mydataToken)
          config.headers["Authorization"] = "Bearer " + mydataToken

          JSUtils?.getConfigAddonHeaders(config)
          getAddOnHeadersGlobal(
            config,
            isSaasView ? "saas-view" : "normal-view"
          )
        } else {
          localStorage.clear()
          UserService.doLogout()
        }
      } else {
        config.headers["Authorization"] =
          localStorage.getItem("token") === null
            ? ""
            : "Bearer " + localStorage.getItem("token")
        JSUtils?.getConfigAddonHeaders(config)
        getAddOnHeadersGlobal(config, isSaasView ? "saas-view" : "normal-view")
      }
    } else {
      localStorage.clear()
      UserService.doLogout()
    }
    //PATH VARIABLES IS AVAILABLE
    if (config.headers.path) {
      try {
        config.url = bindPath(config.url, config.headers.path)
      } catch (e) {}
    }
    delete config.headers.path
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

const locationKcAxios = Axios.create()

locationKcAxios.interceptors.request.use(
  async function (config) {
    config.baseURL = config?.baseURL || URLS.baseURL_KC
    // //CHECK REQUEST NEED TO ADD AUTH TOKEN IN THE HEADER
    if (UserService.isLoggedIn()) {
      if (UserService.isAuthExpired() === true) {
        const myData = await UserService.updateRefreshToken()
        if (myData === true) {
          let mydataToken = UserService.getToken((res) => {
            return res
          })
          localStorage.setItem("token", mydataToken)
          config.headers["Authorization"] = "Bearer " + mydataToken
          let tenantId =
            localStorage.getItem("tenantId") === null
              ? ""
              : localStorage.getItem("tenantId")
          config.headers["X-Tenant-ID"] = tenantId
          config.headers["X-KC-Realm-ID"] = localStorage.getItem(
            "X-KC-Realm-ID"
          )
          config.headers["X-KC-Host"] = localStorage.getItem("X-KC-Host")
          JSUtils?.getConfigAddonHeaders(config)
          getAddOnHeadersGlobal(config)
        } else {
          localStorage.clear()
          UserService.doLogout()
        }
      } else {
        let tenantId =
          localStorage.getItem("tenantId") === null
            ? ""
            : localStorage.getItem("tenantId")
        config.headers["X-Tenant-ID"] = tenantId
        config.headers["X-KC-Realm-ID"] = localStorage.getItem("X-KC-Realm-ID")
        config.headers["X-KC-Host"] = localStorage.getItem("X-KC-Host")
        config.headers["Authorization"] =
          localStorage.getItem("token") === null
            ? ""
            : "Bearer " + localStorage.getItem("token")
        JSUtils?.getConfigAddonHeaders(config)
        getAddOnHeadersGlobal(config)
      }
    } else {
      localStorage.clear()
      UserService.doLogout()
    }
    if (config.headers.path) {
      try {
        config.url = bindPath(config.url, config.headers.path)
      } catch (e) {}
    }
    delete config.headers.path
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

export const locationApiMethods = {
  getAllLocations: (bodyData) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return locationAxios.post(URLS.endpoints.getLocations, bodyData, options)
  },
  getAllLocationGroups: (bodyData) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return locationAxios.post(
      URLS.endpoints.getLocationGroups,
      bodyData,
      options
    )
  },
  getLocationHierarchy: (cancelSource = { current: undefined }) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    if (cancelSource?.current) {
      cancelSource.current()
    }
    return locationAxios.get(URLS.endpoints.getLocationHierarchy, {
      cancelToken: new CancelToken(function executor(c) {
        cancelSource.current = c
      }),
      ...options,
    })
  },
  createHierarchy: (bodyData) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return locationAxios.post(URLS.endpoints.create, bodyData, options)
  },
  updateHierarchy: (hierarchyID, bodyData) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return locationAxios.post(URLS.endpoints.updateHierarchy, bodyData, {
      ...options,
      headers: { path: { hierarchyID } },
    })
  },
  updateLocationHierarchyMappings: (bodyData) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return locationAxios.post(
      URLS.endpoints.updateLocationHierarchyMappings,
      bodyData,
      options
    )
  },
  updateStorageHierarchyMappings: (bodyData) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return locationAxios.post(
      URLS.endpoints.updateStorageHierarchyMappings,
      bodyData,
      options
    )
  },
  deleteHierarchy: (hierarchyID) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return locationAxios.delete(URLS.endpoints.deleteHierarchy, {
      ...options,
      headers: { path: { hierarchyID } },
    })
  },
  deleteLocationGroups: (bodyData) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return locationAxios.delete(
      URLS.endpoints.deleteLocationGroups,
      bodyData,
      options
    )
  },
  deleteLocation: (bodyData) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return locationAxios.delete(
      URLS.endpoints.deleteLocation,
      {
        data: bodyData,
      },
      options
    )
  },
  elasticSearchKCLocation: (bodyData) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    const sort = bodyData.sort
    const sortValues = Object.entries(sort)
    const payload = {
      params: {
        searchParam: bodyData.searchTerm,
        sortpara: sortValues?.[0]?.[0],
        sortvalue: sortValues?.[0]?.[1] === "asc" ? 0 : 1,
        itemcount: bodyData.limit,
        pagenumber: bodyData.page,
      },
    }
    return locationKcAxios.get(
      URLS.endpoints.searchKcLocations,
      payload,
      options
    )
  },
  elasticSearchLocation: (bodyData) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }

    return locationAxios.post(URLS.endpoints.getLocations, bodyData, options)
  },
  elasticSearchLocationLiveMonitoring: (bodyData) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return locationAxios.post(
      LOC_HIERARCHY_LIVE_URLS.endpoints.getLocationsLiveMonitoring,
      bodyData,
      {
        baseURL: LOC_HIERARCHY_LIVE_URLS?.baseURL,
        ...options,
      }
    )
  },
}
export default locationApiMethods
